import styled from "styled-components";

export const CSVButtonWrapper = styled.div`
  flex: 1;
  position: relative;
  float: right;
  margin: 0 0 0 20px;

  & button {
    float: right;
  }
`;

export const CustomDropdown = styled.div`
  position: absolute;
  background-color: white;
  border: 1px solid #ccc;
  box-shadow: 1px 1px 5px #888;
  border-radius: 4px;
  z-index: 1;
  right: 0;
  top: 42px;
  width: max-content;
`;

export const ClickWrapper = styled.div`
  cursor: pointer;
  & a {
    color: #323232;
    font-family: "Open Sans", sans-serif;
    font-size: 15px !important;
    text-align: left;
    border-bottom: 1px solid #cccc;
    padding: 5px 15px;
    float: left;
    width: 100%;
    cursor: pointer;
  }
`;

export const CSVSEND = styled.div`
  color: #323232;
  font-family: "Open Sans", sans-serif;
  font-size: 14px !important;
  text-align: left;
  margin-top: 8px;
  cursor: pointer;
`;

export const OptionText = styled.div`
  color: ${({ isDisabled }) => (isDisabled ? "#9e9e9e" : "rgb(50, 50, 50)")};
  font-family: "Open Sans", sans-serif;
  text-align: left;
  border-bottom: 1px solid rgba(204, 204, 204, 0.8);
  padding: 5px 15px;
  float: left;
  width: 100%;
  font-size: 15px !important;
  cursor: ${({ isDisabled }) => (isDisabled ? "not-allowed" : "pointer")};
`;
